import Vue from "vue";
import VueRouter from "vue-router";
import {overWriteRoute, findRoutes} from '@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/routes/RouterFunctions'
import {dashboardRoutes} from '@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/routes/DashboardRoutes'
import {siteRoutes} from '@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/routes/SiteRoutes'

// import auth views
import Login from "@/views/site/auth/Login";
import Register from "@/views/site/auth/Register";
import ForgotPassword from "@/views/site/auth/ForgetPassword";
import EmailResetPassword from "@/views/site/auth/ResetEmailPassword";
import CellphoneResetPassword from "@/views/site/auth/ResetCellPhonePassword";
import VerifiedCellphone from "@/views/site/auth/VerifiedCellphone";
import VerifiedEmail from "@/views/site/auth/VerifiedEmail";

//import site views
import Home from "../views/Home";

import Product from '@/views/site/SingleProduct'
import Products from '@/views/site/Products'
import NotFound from "@/views/NotFound";
import SiteTemplate from "@/views/site/SiteTemplate";
import SingleCourse from "@/views/site/SingleCourse";
import SinglePost from "@/views/site/SinglePost";
import Course from "@/views/site/Course";
import ShoppingCart from "@/views/site/ShoppingCart";
import UnAuthenticatedShoppingCart from "@/views/site/UnAuthenticatedShoppingCart";
import SingleLesson from "@/views/site/SingleLesson";
import verifyTransaction from "@/views/site/VerifyTransaction";
import Factor from "@/views/site/Factor";
import Delivery from "@/views/site/Delivery";
import Payment from "@/views/site/Payment";
import Posts from "@/views/site/Posts";

Vue.use(VueRouter);


overWriteRoute(siteRoutes, 'Login', {components: {site: Login}})
overWriteRoute(siteRoutes, 'Register', {components: {site: Register}})
overWriteRoute(siteRoutes, 'ForgetPassword', {components: {site: ForgotPassword}})
overWriteRoute(siteRoutes, 'EmailResetPassword', {components: {site: EmailResetPassword}})
overWriteRoute(siteRoutes, 'VerifiedEmail', {components: {site: VerifiedEmail}})
overWriteRoute(siteRoutes, 'VerifiedCellphone', {components: {site: VerifiedCellphone}})
overWriteRoute(siteRoutes, 'CellphoneResetPassword', {components: {site: CellphoneResetPassword}})
overWriteRoute(siteRoutes, 'ShoppingCart', {components: {site: ShoppingCart}})
overWriteRoute(siteRoutes, 'verifyTransaction', {components: {site: verifyTransaction}})
overWriteRoute(siteRoutes, 'Product', {components: {site: Product}})
overWriteRoute(siteRoutes, 'Products', {components: {site: Products}})
overWriteRoute(siteRoutes, 'Courses', {components: {site: Course}})
overWriteRoute(siteRoutes, 'SingleCourse', {components: {site: SingleCourse}})
overWriteRoute(siteRoutes, 'SingleLesson', {components: {site: SingleLesson}})
overWriteRoute(siteRoutes, 'Factor', {components: {site: Factor}})
overWriteRoute(siteRoutes, 'UnAuthenticatedShoppingCart', {components: {site: UnAuthenticatedShoppingCart}})
overWriteRoute(siteRoutes, 'Delivery', {components: {site: Delivery}})
overWriteRoute(siteRoutes, 'Payment', {components: {site: Payment}})
overWriteRoute(siteRoutes, 'Posts', {components: {site: Posts}})
overWriteRoute(siteRoutes, 'SinglePost', {components: {site: SinglePost}})

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    ...dashboardRoutes,
    {
        path: '/template',
        name: 'Template',
        component: SiteTemplate,
        children: [
            ...siteRoutes,
        ]
    },
    {
        path: '*',
        name: 'NotFound',
        component: NotFound
    },
]


const router = new VueRouter({
    routes,
    mode: "history",
});

export default router;
